import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

function AttendanceSummaryBar({ summary, onMarkAllPresent, canEdit }) {
  const { t: tr } = useTranslation();
  const showMarkAllPresent = summary.total > 2;

  return (
    <div className="attendance-page__summary">
      <div className="attendance-page__summary-counts">
        <strong>{summary.total}</strong> {tr('manage:attendance.students', { count: summary.total })}<span> - </span><strong className="text-success">{summary.present}</strong> {tr("manage:present_65")}<span> - </span><strong className="text-danger">{summary.absent}</strong> {tr("manage:absent_66")}<span> - </span><strong className="text-warning">{summary.cancelledOnTime + summary.cancelledLate}</strong> {tr("manage:cancelled_67")}<span> - </span><strong>{summary.unmarked}</strong> {tr("manage:unmarked_68")}</div>
      {showMarkAllPresent && (
        <button type="button" className="btn btn-outline-secondary" disabled={!canEdit} onClick={onMarkAllPresent}>{tr("manage:markEveryoneAsPresent_69")}</button>
      )}
    </div>
  );
}

AttendanceSummaryBar.propTypes = {
  summary: PropTypes.object.isRequired,
  onMarkAllPresent: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default AttendanceSummaryBar;
